import {
  Box,
  Flex,
  Stack,
  Heading,
  Text,
  Container,
  Input,
  Button,
  SimpleGrid,
  Avatar,
  AvatarGroup,
  useBreakpointValue,
  IconProps,
  Icon,
  Textarea,
  toast,
  useToast,
} from "@chakra-ui/react";
import React, { useEffect } from "react";
import { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router";
import { contactUs } from "../../../redux/actions/user/UserActions";
import { RootStore } from "../../../redux/Store";
import {
  CLEAR_CONTACT_SUBSCRIBE_MESSAGE,
  CLEAR_MESSAGE,
} from "../../../redux/types/user/UserActionTypes";

export default function ContactUs() {
  const [contactClickState, setContactClickState] = useState(false);
  const [contactData, setContactData] = useState<IContact>();
  const dispatch = useDispatch();
  const history = useHistory();
  const validation = (): boolean => {
    let isValid = true;

    if (
      !contactData?.fullName ||
      !contactData.email ||
      !contactData.address ||
      !contactData.phoneNumber ||
      !contactData.message
    ) {
      isValid = false;
    }

    return isValid;
  };
  const emailPatternValidation = (): boolean => {
    let isValid = true;
    if (contactData?.email) {
      var pattern = new RegExp(
        /^(("[\w-\s]+")|([\w-]+(?:\.[\w-]+)*)|("[\w-\s]+")([\w-]+(?:\.[\w-]+)*))(@((?:[\w-]+\.)*\w[\w-]{0,66})\.([a-z]{2,6}(?:\.[a-z]{2})?)$)|(@\[?((25[0-5]\.|2[0-4][0-9]\.|1[0-9]{2}\.|[0-9]{1,2}\.))((25[0-5]|2[0-4][0-9]|1[0-9]{2}|[0-9]{1,2})\.){2}(25[0-5]|2[0-4][0-9]|1[0-9]{2}|[0-9]{1,2})\]?$)/i
      );
      if (!pattern.test(contactData.email)) {
        isValid = false;
      }
    }
    return isValid;
  };
  const phoneNumberValidation = (): boolean => {
    let isValid = true;

    if (contactData?.phoneNumber) {
      if (contactData.phoneNumber?.length != 10) {
        isValid = false;
      } else if (isNaN(Number(contactData.phoneNumber))) {
        isValid = false;
      }
    }
    return isValid;
  };
  const handleSubmit = () => {
    setContactClickState(true);
    if (validation() && emailPatternValidation() && phoneNumberValidation()) {
      const contactUsData = {
        fullName: contactData?.fullName,
        email: contactData?.email,
        address: contactData?.address,
        phoneNumber: contactData?.phoneNumber,
        message: contactData?.message,
      };
      dispatch(contactUs(contactUsData, history));
    }
  };
  const userState = useSelector((state: RootStore) => state.user);
  const toast = useToast();
  useEffect(() => {
    if (userState.message) {
      toast({
        title: "Contact Us",
        description: userState.message,
        status: "success",
        duration: 2000,
        isClosable: true,
      });

      dispatch({ type: CLEAR_CONTACT_SUBSCRIBE_MESSAGE });
    }
  }, [userState.message]);
  return (
    <Box position={"relative"}>
      <Container
        as={SimpleGrid}
        maxW={"7xl"}
        columns={{ base: 1, md: 2 }}
        spacing={{ base: 10, lg: 32 }}
        py={{ base: 10, sm: 20, lg: 32 }}
      >
        <Stack spacing={{ base: 10, md: 20 }}>
          <Heading
            lineHeight={1.1}
            fontSize={{ base: "3xl", sm: "4xl", md: "5xl", lg: "6xl" }}
          >
            Nice to meet{" "}
            <Text
              as={"span"}
              bgGradient="linear(to-r, red.400,pink.400)"
              bgClip="text"
            >
              &
            </Text>{" "}
            {"Love to Hear from you"}
          </Heading>
          <Stack direction={"row"} spacing={4} align={"center"}>
            <Text
              fontFamily={"heading"}
              fontSize={{ base: "xl", md: "2xl" }}
              fontWeight="bold"
            >
              Our Growing Community
            </Text>
            <Text fontFamily={"heading"} fontSize={{ base: "4xl", md: "6xl" }}>
              +
            </Text>
            <Flex
              align={"center"}
              justify={"center"}
              fontFamily={"heading"}
              fontSize={{ base: "sm", md: "lg" }}
              bg={"gray.800"}
              color={"white"}
              rounded={"full"}
              width={useBreakpointValue({ base: "44px", md: "60px" })}
              height={useBreakpointValue({ base: "44px", md: "60px" })}
              position={"relative"}
              _before={{
                content: '""',
                width: "full",
                height: "full",
                rounded: "full",
                transform: "scale(1.125)",
                bgGradient: "linear(to-bl, orange.400,yellow.400)",
                position: "absolute",
                zIndex: -1,
                top: 0,
                left: 0,
              }}
            >
              YOU
            </Flex>
          </Stack>
        </Stack>
        <Stack
          bg={"gray.50"}
          rounded={"xl"}
          p={{ base: 4, sm: 6, md: 8 }}
          spacing={{ base: 8 }}
          maxW={{ lg: "lg" }}
        >
          <Stack spacing={4}>
            <Heading
              color={"gray.800"}
              lineHeight={1.1}
              fontSize={{ base: "2xl", sm: "3xl", md: "4xl" }}
            >
              Contact Us
              <Text
                as={"span"}
                bgGradient="linear(to-r, red.400,pink.400)"
                bgClip="text"
              >
                !
              </Text>
            </Heading>
            <Text color={"gray.500"} fontSize={{ base: "sm", sm: "md" }}>
              Our team is happy to answer your queries. Fill out the form and
              we'll be in touch as soon as possible.
            </Text>
          </Stack>
          <Box as={"form"} mt={10}>
            <Stack spacing={4}>
              <Input
                isInvalid={
                  contactClickState ? !contactData?.fullName && true : false
                }
                id="fullName"
                name="fullName"
                placeholder="fullname"
                bg={"gray.100"}
                border={0}
                color={"gray.500"}
                onChange={(event) =>
                  setContactData({
                    ...contactData,
                    fullName: event.target.value,
                  })
                }
                _placeholder={{
                  color: "gray.500",
                }}
              />
              {contactClickState && !contactData?.fullName && (
                <Text fontSize="xs" color="red">
                  {"This field must not be empty"}
                </Text>
              )}
              <Input
                isInvalid={
                  contactClickState ? !contactData?.email && true : false
                }
                onChange={(event) =>
                  setContactData({
                    ...contactData,
                    email: event.target.value,
                  })
                }
                id="email"
                name="email"
                placeholder="firstname@lastname.io"
                bg={"gray.100"}
                type="email"
                border={0}
                color={"gray.500"}
                _placeholder={{
                  color: "gray.500",
                }}
              />
              {contactClickState && (
                <Text fontSize="xs" color="red">
                  {!contactData?.email
                    ? "This field must not be empty"
                    : !emailPatternValidation() &&
                      "Please enter a valid email address"}
                </Text>
              )}
              <Input
                isInvalid={
                  contactClickState ? !contactData?.address && true : false
                }
                onChange={(event) =>
                  setContactData({
                    ...contactData,
                    address: event.target.value,
                  })
                }
                id="address"
                name="address"
                placeholder="location@nepal"
                bg={"gray.100"}
                border={0}
                color={"gray.500"}
                _placeholder={{
                  color: "gray.500",
                }}
              />
              {contactClickState && !contactData?.address && (
                <Text fontSize="xs" color="red">
                  {"This field must not be empty"}
                </Text>
              )}
              <Input
                isInvalid={
                  contactClickState ? !contactData?.phoneNumber && true : false
                }
                onChange={(event) =>
                  setContactData({
                    ...contactData,
                    phoneNumber: event.target.value,
                  })
                }
                id="phoneNumber"
                name="phoneNumber"
                placeholder="+977-__-__-___-___"
                bg={"gray.100"}
                border={0}
                color={"gray.500"}
                _placeholder={{
                  color: "gray.500",
                }}
              />
              {contactClickState && (
                <Text fontSize="xs" color="red">
                  {!contactData?.phoneNumber
                    ? "This field must not be empty"
                    : !phoneNumberValidation() &&
                      "Please enter a valid phone number"}
                </Text>
              )}
              <Textarea
                isInvalid={
                  contactClickState ? !contactData?.message && true : false
                }
                onChange={(event) =>
                  setContactData({
                    ...contactData,
                    message: event.target.value,
                  })
                }
                id="message"
                name="message"
                placeholder="your queries / problems"
                bg={"gray.100"}
                maxH="48"
                border={0}
                color={"gray.500"}
                _placeholder={{
                  color: "gray.500",
                }}
              />
              {contactClickState && !contactData?.message && (
                <Text fontSize="xs" color="red">
                  {"This field must not be empty"}
                </Text>
              )}
            </Stack>
            <Button
              fontFamily={"heading"}
              mt={8}
              w={"full"}
              bgGradient="linear(to-r, red.400,pink.400)"
              color={"white"}
              onClick={handleSubmit}
              _hover={{
                bgGradient: "linear(to-r, red.400,pink.400)",
                boxShadow: "xl",
              }}
              _focus={{
                outline: "none",
                boxShadow: "none",
                textDecor: "none",
              }}
              id="submitButton"
              name="submitButton"
            >
              Submit
            </Button>
          </Box>
        </Stack>
      </Container>
      <Blur
        position={"absolute"}
        top={50}
        left={15}
        style={{ filter: "blur(80px)" }}
      />
    </Box>
  );
}

export const Blur = (props: IconProps) => {
  return (
    <Icon
      width={useBreakpointValue({ base: "100%", md: "40vw", lg: "30vw" })}
      zIndex={useBreakpointValue({ base: -1, md: -1, lg: 0 })}
      height="560px"
      viewBox="0 0 528 560"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <circle cx="71" cy="61" r="111" fill="#F56565" />
      <circle cx="244" cy="106" r="139" fill="#ED64A6" />
      <circle cy="291" r="139" fill="#ED64A6" />
      <circle cx="80.5" cy="189.5" r="101.5" fill="#ED8936" />
      <circle cx="196.5" cy="317.5" r="101.5" fill="#ECC94B" />
      <circle cx="70.5" cy="458.5" r="101.5" fill="#48BB78" />
      <circle cx="426.5" cy="-0.5" r="101.5" fill="#4299E1" />
    </Icon>
  );
};
